export default defineNuxtRouteMiddleware((to) => {
    // skip middleware on server side, this is only for updating the canonical link on the client
    if (import.meta.server) return;
    useSetCanonicalUrl(to.fullPath);
});
